import React, { useState } from 'react';

import * as api from 'api/methods';

import { getUnknownErrorMessage } from 'helpers/unknownErrorMessage';

import ForgotPasswordForm from './ForgotPasswordForm';
import { useLocation } from 'react-router-dom';

const ForgotPasswordFormContainer = ({
  onFormSubmitted,
}: {
  onFormSubmitted: any;
}) => {
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (
    values: any,
    { setFieldError }: { setFieldError: any },
  ) => {
    setLoading(true);

    try {
      await api.forgotPassword(values);

      setLoading(false);

      if (onFormSubmitted) {
        onFormSubmitted(values.email);
      }
    } catch (error) {
      setLoading(false);

      setFieldError('email', getUnknownErrorMessage(error));
    }
  };

  return (
    <ForgotPasswordForm
      loading={loading}
      emailFromAuth={location.state.email}
      onSubmit={handleSubmit}
    />
  );
};

export default React.memo(ForgotPasswordFormContainer) as any;
